/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Birth_WordsInputs */

const en_us2_search_field_birth_words = /** @type {(inputs: Search_Field_Birth_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`birth age birthday years`)
};

const pt_br2_search_field_birth_words = /** @type {(inputs: Search_Field_Birth_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nascimento idade aniversario anos`)
};

const es_419_search_field_birth_words = /** @type {(inputs: Search_Field_Birth_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nacimiento edad cumpleanos anos`)
};

const pt_pt2_search_field_birth_words = /** @type {(inputs: Search_Field_Birth_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nascimento idade aniversario anos`)
};

const fr_fr2_search_field_birth_words = /** @type {(inputs: Search_Field_Birth_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`naissance age anniversaire ans`)
};

const de_de2_search_field_birth_words = /** @type {(inputs: Search_Field_Birth_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`geburt alter geburtstag jahre`)
};

const it_it2_search_field_birth_words = /** @type {(inputs: Search_Field_Birth_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nascita eta compleanno anni`)
};

/**
* | output |
* | --- |
* | "birth age birthday years" |
*
* @param {Search_Field_Birth_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_birth_words = /** @type {((inputs?: Search_Field_Birth_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Birth_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_birth_words(inputs)
	if (locale === "es-419") return es_419_search_field_birth_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_birth_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_birth_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_birth_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_birth_words(inputs)
	return en_us2_search_field_birth_words(inputs)
});
export { search_field_birth_words as "search.field_birth_words" }